import React from 'react';
import moment from 'moment';
import XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'

import Loader from './../../../component/common/Loader';
import CONSTANT from '../../../constant';
import Header from '../../../component/common/LeaveHeader';
import { getUnitList } from '../../../actions/MasterAction';
import { getLeaveMonthlyLeaveReport } from '../../../actions/LeaveAction';
import { onChange, validateForm,setOptions } from '../../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const startDate = moment().startOf('month').format('YYYY-MM-DD');
        // const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        // const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');
        const endOfMonth = moment().format('YYYY-MM-DD');
        this.state = {
            startDate: { name: 'startDate', value: startDate, error: '', isRequired: true },
            endDate: { name: 'endDate', value: endOfMonth, error: '', isRequired: true },
            unitCode: { name: 'unitCode', value: '', options: [], error: '' },
            list: [],
            listSortData:[],
            showLoader: false
        }

    }
    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;
        getUnitList().then((res: any) => {
            setOptions(this, this.state.unitCode.name, res.result);
        });
    }

    render() {
        const { startDate, endDate, list, showLoader, unitCode } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Leaves Availed Between</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-7"></div>
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header">Search Leaves Availed Between</div>
                                    <div className="card-body">
                                        <form onSubmit={this.onSubmit}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Start Date *</label>
                                                        <input
                                                            type="date"
                                                            className={startDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            name={startDate.name}
                                                            value={startDate.value}
                                                            onChange={this.onChange}
                                                            max={moment().format('YYYY-MM')}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>End Date *</label>
                                                        <input
                                                            type="date"
                                                            className={endDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            name={endDate.name}
                                                            value={endDate.value}
                                                            onChange={this.onChange}
                                                            max={moment().format('YYYY-MM-DD')}
                                                            min={moment(startDate.value).format('YYYY-MM-DD')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                {/* <div className="col-md-4">
                                                    <button type="button" disabled={list.length === 0} onClick={this.downloadExcel} className="btn btn-sm submit-button btn-block">Excel Report</button>
                                                </div> */}

                                                <div className="col-md-6">
                                                    <button type="button" disabled={list.length === 0} onClick={this.downloadPdf} className="btn btn-sm submit-button btn-block"> Pdf Report</button>
                                                    <p id="showData"></p>
                                                </div>
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-sm submit-button btn-block">Search</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                                <div className="form-group">
                                                    {/* <label>Sort By</label> */}
                                                    <select
                                                        value={unitCode.value}
                                                        className={unitCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        onChange={this.onChange}
                                                        name={unitCode.name}>
                                                        <option value="">Sort By Unit</option>
                                                        {
                                                            unitCode.options.map((item: any, index: number) => {
                                                                // this.setState({listSortData:[...item.name]})
                                                                return <option key={index} value={item.name}>{item.name}</option>

                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <button type="submit" className="col-lg-5 btn btn-sm submit-button btn-block  pull-right" onClick={this.printPDF}>Print Page</button>

                                        {/* <button className="col-lg-3 btn button-full mt-4 pull-right" onClick={this.printPDF}>Print Report</button> */}
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover" id="printPage" >
                                        <tbody >
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Employee Number</th>
                                                <th scope="col">Name</th>
                                                <th scope="col" title="Casual leave">CL</th>
                                                <th scope="col" title="RH">RH</th>
                                                <th scope="col" title="Encashable">EL</th>
                                                <th scope="col" title="Non-Encashable">NON-EL</th>
                                                {/* <th scope="col" title="Non-Encashable">CML</th> */}
                                                <th scope="col" title="HPL">CML</th>
                                                <th scope="col" title="HPL">Unit</th>
                                            </tr>
                                            {
                                                list === undefined && <tr>
                                                    <td colSpan={10} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.length === 0 && <tr>
                                                    <td colSpan={10} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.filter((item: any) => unitCode.value ? item.unitName == unitCode.value : true).map((item: any, index: number) => {
                                                    // const detailPageURL = `${CONSTANT.component.adminAddLeave}?code=${item.code}`;
                                                    const cl = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.cl)[0];
                                                    const rh = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.rh)[0];
                                                    const el = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.el)[0];
                                                    const nonel = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.nonel)[0];
                                                    // const cml = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.cml)[0];
                                                    const hpl = item.leaveDetail.filter((j: any) => j.code === CONSTANT.static.leaveType.hpl)[0];;
                                                    return (
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{item.employeeNumber}</td>
                                                            <td>{item.name}</td>
                                                            <td>
                                                                {`${cl.used}`}
                                                                {
                                                                   cl.detail && cl.detail.length > 0 &&
                                                                    <React.Fragment>
                                                                        <br />
                                                                        <small>
                                                                            {cl.detail.map((i: any) => { return `${moment(i.startDate).format('DD MMM YYYY')} - ${moment(i.endDate).format('DD MMM YYYY')}` }).join(', ')}
                                                                        </small>
                                                                    </React.Fragment>
                                                                }
                                                            </td>
                                                            <td>
                                                                {`${rh.used}`}
                                                                {
                                                                    rh.detail && rh.detail.length > 0 &&
                                                                    <React.Fragment>
                                                                        <br />
                                                                        <small>
                                                                            {rh.detail.map((i: any) => { return `${moment(i.startDate).format('DD MMM YYYY')} - ${moment(i.endDate).format('DD MMM YYYY')}` }).join(', ')}
                                                                        </small>
                                                                    </React.Fragment>
                                                                }
                                                            </td>
                                                            <td>
                                                                {`${el.used}`}
                                                                {
                                                                    el.detail && el.detail.length > 0 &&
                                                                    <React.Fragment>
                                                                        <br />
                                                                        <small>
                                                                            {el.detail.map((i: any) => { return `${moment(i.startDate).format('DD MMM YYYY')} - ${moment(i.endDate).format('DD MMM YYYY')}` }).join(', ')}
                                                                        </small>
                                                                    </React.Fragment>
                                                                }
                                                            </td>
                                                            <td>
                                                                {`${nonel.used}`}
                                                                {
                                                                    nonel.detail && nonel.detail.length > 0 &&
                                                                    <React.Fragment>
                                                                        <br />
                                                                        <small>
                                                                            {nonel.detail.map((i: any) => { return `${moment(i.startDate).format('DD MMM YYYY')} - ${moment(i.endDate).format('DD MMM YYYY')}` }).join(', ')}
                                                                        </small>
                                                                    </React.Fragment>
                                                                }
                                                            </td>
                                                            {/* <td>
                                                                {`${cml.used}`}
                                                                {
                                                                    cml.detail && cml.detail.length > 0 &&
                                                                    <React.Fragment>
                                                                        <br />
                                                                        <small>
                                                                            {cml.detail.map((i: any) => { return `${moment(i.startDate).format('DD MMM YYYY')} - ${moment(i.endDate).format('DD MMM YYYY')}` }).join(', ')}
                                                                        </small>
                                                                    </React.Fragment>
                                                                }
                                                            </td> */}
                                                            <td>
                                                                {`${hpl.used}`}
                                                                {
                                                                    hpl.detail && hpl.detail.length > 0 &&
                                                                    <React.Fragment>
                                                                        <br />
                                                                        <small>
                                                                            {hpl.detail.map((i: any) => { return `${moment(i.startDate).format('DD MMM YYYY')} - ${moment(i.endDate).format('DD MMM YYYY')}` }).join(', ')}
                                                                        </small>
                                                                    </React.Fragment>
                                                                }
                                                            </td>
                                                            <td>{item.unitName}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div >
        )
    }


    onSubmit = (e: any) => {
        
        e.preventDefault();
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const { startDate, endDate } = this.state;
            // const startDate = moment(moment(endDate.value, 'YYYY-MM-DD')).startOf('year').format('YYYY-MM-DD');
            getLeaveMonthlyLeaveReport(startDate.value, endDate.value).then((res: any) => {
                this.setState({ list: res.result, showLoader: false });
            });
        }

    }

    onChange = (e: any) => {
        const name = e.target.name;
        let value = e.target.value;
        onChange(this, name, value);
        // this.setState({list:})
    }

    // downloadExcel = (e: any) => {
    //     const { list, endDate } = this.state;

    //     const date = moment(endDate.value);
    //     if (list.length === 0) {
    //         alert('No records found.');
    //         return;
    //     }

    //     let filename = `leave - balance - ${date.format('MMMM-YYYY')}.xlsx`;
    //     let dataToExport: any = [];
    //     var ws_name = "Sheet1";
    //     list.map(function (item: any) {
    //         delete item.code;
    //         const cl = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.cl)[0];
    //         const el = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.el)[0];
    //         const nonel = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.nonel)[0];
    //         const hpl = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.hpl)[0];
    //         const rh = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.rh)[0];
    //         // const cml = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.cml)[0];

    //         const dated = date.format('MMM YYYY');

    //         dataToExport.push({
    //             EmployeeNumber: item.employeeNumber,
    //             Name: item.name,
    //             Dated: dated,
    //             Unit: item.unitName,

    //             "CL Total": cl.total,
    //             "CL Used": cl.used,
    //             "RH Total": rh.total,
    //             "RH Used": rh.used,
    //             "EL Total": el.total,
    //             "EL Used": el.used,
    //             "NON-EL Total": nonel.total,
    //             "NON-EL Used": nonel.used,
    //             "CML Total": hpl.total,
    //             "CML Used": hpl.used,
                
    //         });
    //     });
    //     var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(dataToExport);
    //     XLSX.utils.book_append_sheet(wb, ws, ws_name);
    //     XLSX.writeFile(wb, filename);
    //     // });
    // }
    private printPDF = ()=>{
        //  @ts-ignore 
    var style = "<style>";
    style = style + "table {width: 100%;height: 100%;font: 17px Calibri;}";
    style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
    style = style + "padding: 2px 3px;text-align: center;}";
    style = style + "</style>";
    //
    var tab = document.getElementById("printPage");
            //  @ts-ignore 
    var win = window.open('', '', 'width=800,height=700');
                //  @ts-ignore 
    win.document.write(style);
                    //  @ts-ignore 
    win.document.write(tab.outerHTML);
                    //  @ts-ignore 
    win.document.close();
                    //  @ts-ignore 
    win.print();
   }

    downloadPdf =(e: any)=>{
        const { list, endDate } = this.state;
        const date = moment(endDate.value);
        if (list.length === 0) {
            alert('No records found.');
            return;
        } 
        let filename = `leave - balance - ${date.format('MMMM-YYYY')}.pdf`;

//    @ts-ignore 
    //    doc.autoTable( {
    //     body: dataToExport, 
        // startY: 30,
        // margin: { horizontal: 10 },
        // styles: { columnWidth: 'wrap' },
        // columnStyles: {
        // text: { columnWidth: 'auto' },
        // nil: { halign: 'right' },
        // tgl: { halign: 'right' },
        // headerStyles: {
        //     head:col,
        //     lineWidth: 0.35,
        //     lineColor: [0, 0, 0],
        //     valign: 'middle',
        //     halign: 'center',
        //     fontStyle: 'bold'
        //   },
        //   bodyStyles: {
        //     lineWidth: 0.35,
        //     lineColor: [0, 0, 0]
        //   },
        
    // },
    //     headerStyles: { halign: 'center' },
    //     theme: 'grid',
    // });
    // doc.autoTable(dataToExport,heading, 
    //   )
    //  @ts-ignore 
    // {
    //     unitCode.options.map((item: any, index: number) => {
    //         this.setState({ list: item.name});
    //         // return <option key={index} value={item.name}>{item.name}</option>
    //     })
    
    const doc = new jsPDF("landscape",'pt','a4');
    doc.setFontSize(15);
    let dataToExport: any = [];
    const{unitCode}=this.state;
    const headers = [["EmployeeNumber", "Name", "Dated","Unit", "CL Total","CL Used", "RH Total" ,"RH Used","EL Total","EL Used", "NON-EL Total", "NON-EL Used","CML Total","CML Used"]];
    const data = list.filter((item: any) => unitCode.value ? item.unitName == unitCode.value : true).map((item: any, index: number) => {
        
        const cl = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.cl)[0];
        const el = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.el)[0];
        const nonel = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.nonel)[0];
        const hpl = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.hpl)[0];
        const rh = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.rh)[0];
        // const cml = item.leaveDetail.filter((i: any) => i.code === CONSTANT.static.leaveType.cml)[0];

        const dated = date.format('MMM YYYY'); 
        dataToExport.push([item.employeeNumber,
             item.name,
             dated,  
             item.unitName,         
             cl.total,
             cl.used,
             rh.total,
             rh.used,
             el.total,
             el.used,
             nonel.total,
             nonel.used,
            //  cml.total,
            //  cml.used,
             hpl.total,
             hpl.used,                        
            ]
        
    );
        })
    
    let content = {
      startY: 10,
      headerStyles: {
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        valign: 'middle',
        halign: 'center',
        fontStyle: 'bold'
      },
      bodyStyles: {
        lineWidth: 0.10,
        lineColor: [0, 0, 0]
      },
      margin: { horizontal: 10 },
      head: headers,
      body: dataToExport
    };
    //  @ts-ignore 
    doc.autoTable(content)
    doc.save(filename)
}
    }

export default ComponentName;